import React from "react";
import { getCurrentStop } from "../../../../utils/utils";
import { getDriverStatus } from "../../../utils/DriverStatus";
import { getDriverStatusIcon } from "../../../utils/DriverStatus/driverStatusIcon";

class DriverStatusIcon extends React.Component {
  constructor(props) {
    super(props);
    const { driverStatus, driverStatusLabel } = getDriverStatus(props, false);
    this.state = {
      driverStatusLabel,
    };
    this.driverStatus = driverStatus;
  }

  refresh = (props) => {
    const { driverStatus, driverStatusLabel } = getDriverStatus(props, false);
    this.setState({
      driverStatusLabel,
    });
    this.driverStatus = driverStatus;
    return true;
  };

  shouldComponentUpdate(_nextProps, nextState) {
    return this.state.driverStatusLabel !== nextState.driverStatusLabel;
  }

  render() {
    const { driverStatusLabel } = this.state;
    if (!driverStatusLabel) {
      return null;
    }
    const currentStop = getCurrentStop(
      this.props.data.currentStatus,
      this.props.data.stops
    );
    const driverStatusIcon = getDriverStatusIcon({
      driverStatus: this.driverStatus,
      currentStop,
    });

    return (
      <div className="driver-status-container">
        <div className="driver-status-icon-container">{driverStatusIcon}</div>
        <div className="driver-status-label">{driverStatusLabel}</div>
      </div>
    );
  }
}

export default DriverStatusIcon;
